import { c as _c } from "react/compiler-runtime";
import { IcoLock16 } from '@onefootprint/icons';
type EncryptedCellProps = {
  prefix?: string;
};
const EncryptedCell = t0 => {
  const $ = _c(3);
  const {
    prefix
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IcoLock16 color="tertiary" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = prefix ? `${prefix}•••••••` : "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022";
  let t3;
  if ($[1] !== t2) {
    t3 = <span className="pointer-events-none inline-flex select-none items-center gap-1.5 align-top text-body-2 text-tertiary">{t1}{t2}</span>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
};
export default EncryptedCell;